import OffersNewsFiatV2LazyCarousel from '../../auto/components/Carousels/FiatV2/OffersNewsLazy';
import NewVehicleFormApp from '../../auto/components/Forms/NewVehicleForm';
import TimeMissingFiatV2 from '../../auto/components/TimeMissingFiatV2';
import FeaturesDisplay from '../../auto/components/Cards/DDM/FeaturesDisplay';

(() => {
  // Adicione aqui chaves:valor com os componentes que serão atribuídos ao escopo
  // global. Não passe eles pelo hyperscript (h) aqui pois a página que os usa
  // é quem deve compilá-lo com os pros.
  const components = {
    OffersNewsFiatV2LazyCarousel,
    NewVehicleFormApp,
    TimeMissingFiatV2,
    FeaturesDisplay,
  };

  Object.keys(components).forEach(c => {
    window[c] = components[c];
  });
})();
